<div class="container mt-4">
  <h2 class="mb-3">{{ title }}</h2>

  <div class="mpc-layout">
    <!-- Left side: List -->
    <div class="mpc-list-side">
      <div class="d-flex align-items-center mb-3 gap-2">
        <input class="form-control" style="max-width: 360px;" [(ngModel)]="search" placeholder="Search (mount point, downloader user)">
        <button class="btn btn-primary" (click)="onSearch()">Search</button>
        <div class="ms-auto d-flex align-items-center gap-2">
          <div class="form-check form-switch me-2">
            <input class="form-check-input" type="checkbox" id="pinSwitch" [checked]="drawerPinned" (change)="togglePin()">
            <label class="form-check-label" for="pinSwitch">Pin details</label>
          </div>
          <button class="btn btn-success" (click)="add()">Add</button>
          <button class="btn btn-danger" (click)="deleteSelected()">Delete</button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped align-middle">
          <thead>
            <tr>
              <th style="width: 36px;"></th>
              <th>Mount Point</th>
              <th>Server</th>
              <th>Port</th>
              <th>Downloader User</th>
              <th>Password</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of rows" (click)="selectRow(r)" [class.table-active]="selected?.mountPointId === r.mountPointId" style="cursor: pointer;">
              <td>
                <input type="checkbox" (change)="toggleSelect(r, $any($event.target).checked)" (click)="$event.stopPropagation()">
              </td>
              <td>{{ r.mountPoint }}</td>
              <td>{{ r.server }}</td>
              <td>{{ r.port }}</td>
              <td>{{ r.downloaderUserName }}</td>
              <td>{{ maskPassword(r.downloaderPassword) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-secondary btn-sm me-2" [disabled]="page===0" (click)="onPageChange(page-1)">Prev</button>
        <span class="align-self-center">Page {{ page + 1 }}</span>
        <button class="btn btn-outline-secondary btn-sm ms-2" [disabled]="(page+1)*size >= total" (click)="onPageChange(page+1)">Next</button>
      </div>
    </div>

    <!-- Right side: Details Panel (toggle-able) -->
    <div class="mpc-details-side" [class.visible]="drawerPinned || !!selected">
      <div class="drawer-header">
        <h4 class="mb-0 subtitle">Mount Point Connection Details</h4>
        <button type="button" class="btn-close ms-auto me-2" aria-label="Close" (click)="closeDetails()"></button>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="editSwitch" [(ngModel)]="editMode" [disabled]="!selected || isDemo" (change)="editMode ? enableEdit() : cancelEdit()">
          <label class="form-check-label" for="editSwitch">Edit</label>
        </div>
      </div>
      <div class="drawer-body" #detailsBody>
        <ng-container *ngIf="selected; else emptyState">
          <div class="details-panel">
            <div class="mb-3">
              <label class="form-label">User ID</label>
              <input class="form-control" [value]="selected!.userId" disabled>
            </div>
            <div class="mb-3">
              <label class="form-label">Mount Point</label>
              <input class="form-control" [(ngModel)]="selected!.mountPoint" [disabled]="!editMode">
            </div>
            <div class="mb-3">
              <label class="form-label">Server</label>
              <input class="form-control" [(ngModel)]="selected!.server" [disabled]="!editMode">
            </div>
            <div class="mb-3">
              <label class="form-label">Port</label>
              <input class="form-control" [(ngModel)]="selected!.port" [disabled]="!editMode">
            </div>
            <div class="mb-3">
              <label class="form-label">Downloader User Name</label>
              <input class="form-control" [(ngModel)]="selected!.downloaderUserName" [disabled]="!editMode">
            </div>
            <div class="mb-3">
              <label class="form-label">Downloader Password</label>
              <input class="form-control" [(ngModel)]="selected!.downloaderPassword" [disabled]="!editMode">
            </div>
          </div>
        </ng-container>
        <ng-template #emptyState>
          <div class="text-muted text-center py-4">Select a connection to view details.</div>
        </ng-template>
      </div>
      <div class="drawer-footer text-end" *ngIf="selected && editMode">
        <button class="btn btn-primary" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</div>


